import React, { Component } from 'react';
import './App.css';
import logo from './pictures/HillCourt@2x.png';
import Menu from './component/MenuComponent'
import Facility from './component/facility'//1
import OverView1 from './component/overView1';//2
import Third from './component/overView'
import Fourth from './component/middle'//upto card
import DemoCarousel from './component/corousel'
import Specific from './component/specification'
import LastPage from './component/lastPage'
import phone from './pictures/phone.png'
class App extends Component {

  render() {
    return (
      <div classNameName="App" >
        <nav className="navigator">
          <img src={logo} alt="" />
          <div className="number">
            <img src={phone} alt="" />
            <div>+91 9999303606</div>
          </div>
          <div className="enquire">
            <div>Enquire now</div>
          </div>
          <div className="button1">
            <ul>
              <li><span>Home</span></li>
              <li>Overview</li>
              <li>Location</li>
              <li>Amenities</li>
              <li>Specification</li>
              <li>About the partners</li>
            </ul>

          </div>
        </nav>
        <Menu />
        <Facility />
        <OverView1 />
        <Third />
        <Fourth />
        <DemoCarousel />
        <Specific />
        <LastPage />
      </div>
    );
  }
}

export default App;
